module.exports = __webpack_public_path__ + "img/smiley VV.90f33dfc.svg";